// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textarea-trabalho {
  width: 100%;
  resize: none;
  padding: 10px;
  font-size: 16px;
  box-sizing: border-box;
  margin-top: 8px;
}

/* ── Bloco agrupado no formulário de trabalho ── */
.work-form-group-box {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background: #f8f9fa;
}

/* ── Contadores ── */
.work-counts {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.work-count-card {
  flex: 1 1;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: #fff;
}

.work-count-card--interno {
  border-color: #b6d4fe;
  background: #f0f6ff;
}

.work-count-card--externo {
  border-color: #b7e4c7;
  background: #f0faf4;
}

.work-count-label {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.work-count-value {
  font-size: 28px;
  font-weight: 700;
  color: #212529;
  line-height: 1;
}

.work-count-card--interno .work-count-value { color: #0056b3; }
.work-count-card--externo .work-count-value { color: #198754; }

/* ── Timeline ── */
.work-timeline {
  position: relative;
  padding-left: 28px;
}

.work-timeline::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 16px;
  bottom: 16px;
  width: 2px;
  background: #dee2e6;
}

.work-timeline-item {
  position: relative;
  margin-bottom: 20px;
}

.work-timeline-dot {
  position: absolute;
  left: -22px;
  top: 18px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #adb5bd;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px #adb5bd;
}

.work-timeline-dot--active {
  background: #28a745;
  box-shadow: 0 0 0 2px #28a745;
}

/* ── Card de trabalho ── */
.work-timeline-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.work-card-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.work-card-dates {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.work-card-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.work-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.work-badge--days {
  background: #cfe2ff;
  color: #084298;
}

.work-badge--active {
  background: #fff3cd;
  color: #664d03;
}

.work-badge--closed {
  background: #e2e3e5;
  color: #41464b;
}

/* ── Grid de campos do card ── */
.work-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 24px;
  margin-bottom: 16px;
}

.work-card-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.work-card-field--full {
  grid-column: 1 / -1;
}

.work-card-field-label {
  font-size: 11px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.work-card-field-value {
  font-size: 14px;
  color: #212529;
  line-height: 1.4;
}

/* ── Ações do card ── */
.work-card-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.work-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  background: #fff;
  color: #495057;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.work-card-btn:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.work-card-btn--launch {
  border-color: #b6d4fe;
  color: #0056b3;
  background: #f0f6ff;
}

.work-card-btn--launch:hover {
  background: #dbeafe;
}

.launch-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 20px;
  background: #0056b3;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
}

/* ── Select dentro do bloco agrupado ── */
.work-form-group-box .med-remedy-wrapper select {
  padding-top: 5px;
  padding-bottom: 5px;
}

/* ── Cards de lançamento (lista no modal) ── */
.launch-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  overflow-y: auto;
  padding-right: 2px;
}

.launch-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
}

.launch-card--editing {
  border-color: #b6d4fe;
  background: #f0f6ff;
}

.launch-card-highlight {
  background: #f0f6ff;
  border: 1px solid #b6d4fe;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.launch-card-highlight-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.launch-card-highlight-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #0056b3;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 3px;
}

.launch-card-period {
  font-weight: 600;
  font-size: 14px;
  color: #212529;
}

.launch-card-edit-btn {
  background: none;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 4px 10px;
  cursor: pointer;
  color: #6c757d;
  font-size: 12px;
  transition: background 0.15s;
}

.launch-card-edit-btn:hover {
  background: #f8f9fa;
  color: #212529;
}

.launch-card-months {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
  min-height: 22px;
}

.launch-month-badge {
  background: #d1e7dd;
  color: #0a3622;
  border-radius: 4px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.launch-card-info {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 12px;
  color: #6c757d;
}

.launch-card-info-item strong {
  color: #495057;
}

/* ── Bloco de período (lançamento) ── */
.launch-period-box {
  border: 1px solid #b6d4fe;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
  background: #f0f6ff;
}

.launch-period-box-title {
  font-size: 11px;
  font-weight: 700;
  color: #0056b3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px;
}

/* ── Linha de dias da semana ── */
.launch-weekdays-row {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  margin-top: 8px;
}

.launch-weekday-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
}

.launch-weekday-label {
  font-size: 11px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.launch-weekday-cell input[type="checkbox"] {
  width: 17px;
  height: 17px;
  cursor: pointer;
  accent-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Trabalho/trabalho.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA,8CAA8C,cAAc,EAAE;AAC9D,8CAA8C,cAAc,EAAE;;AAE9D,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".textarea-trabalho {\n  width: 100%;\n  resize: none;\n  padding: 10px;\n  font-size: 16px;\n  box-sizing: border-box;\n  margin-top: 8px;\n}\n\n/* ── Bloco agrupado no formulário de trabalho ── */\n.work-form-group-box {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  background: #f8f9fa;\n}\n\n/* ── Contadores ── */\n.work-counts {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.work-count-card {\n  flex: 1;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  background: #fff;\n}\n\n.work-count-card--interno {\n  border-color: #b6d4fe;\n  background: #f0f6ff;\n}\n\n.work-count-card--externo {\n  border-color: #b7e4c7;\n  background: #f0faf4;\n}\n\n.work-count-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.work-count-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #212529;\n  line-height: 1;\n}\n\n.work-count-card--interno .work-count-value { color: #0056b3; }\n.work-count-card--externo .work-count-value { color: #198754; }\n\n/* ── Timeline ── */\n.work-timeline {\n  position: relative;\n  padding-left: 28px;\n}\n\n.work-timeline::before {\n  content: '';\n  position: absolute;\n  left: 10px;\n  top: 16px;\n  bottom: 16px;\n  width: 2px;\n  background: #dee2e6;\n}\n\n.work-timeline-item {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.work-timeline-dot {\n  position: absolute;\n  left: -22px;\n  top: 18px;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #adb5bd;\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 2px #adb5bd;\n}\n\n.work-timeline-dot--active {\n  background: #28a745;\n  box-shadow: 0 0 0 2px #28a745;\n}\n\n/* ── Card de trabalho ── */\n.work-timeline-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 16px 20px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n}\n\n.work-card-header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 14px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.work-card-dates {\n  font-size: 13px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.work-card-badges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.work-badge {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.work-badge--days {\n  background: #cfe2ff;\n  color: #084298;\n}\n\n.work-badge--active {\n  background: #fff3cd;\n  color: #664d03;\n}\n\n.work-badge--closed {\n  background: #e2e3e5;\n  color: #41464b;\n}\n\n/* ── Grid de campos do card ── */\n.work-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px 24px;\n  margin-bottom: 16px;\n}\n\n.work-card-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.work-card-field--full {\n  grid-column: 1 / -1;\n}\n\n.work-card-field-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.work-card-field-value {\n  font-size: 14px;\n  color: #212529;\n  line-height: 1.4;\n}\n\n/* ── Ações do card ── */\n.work-card-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.work-card-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n  background: #fff;\n  color: #495057;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.work-card-btn:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.work-card-btn--launch {\n  border-color: #b6d4fe;\n  color: #0056b3;\n  background: #f0f6ff;\n}\n\n.work-card-btn--launch:hover {\n  background: #dbeafe;\n}\n\n.launch-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 20px;\n  background: #0056b3;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 18px;\n}\n\n/* ── Select dentro do bloco agrupado ── */\n.work-form-group-box .med-remedy-wrapper select {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n/* ── Cards de lançamento (lista no modal) ── */\n.launch-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 420px;\n  overflow-y: auto;\n  padding-right: 2px;\n}\n\n.launch-card {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: #fff;\n}\n\n.launch-card--editing {\n  border-color: #b6d4fe;\n  background: #f0f6ff;\n}\n\n.launch-card-highlight {\n  background: #f0f6ff;\n  border: 1px solid #b6d4fe;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.launch-card-highlight-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.launch-card-highlight-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  color: #0056b3;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  margin-bottom: 3px;\n}\n\n.launch-card-period {\n  font-weight: 600;\n  font-size: 14px;\n  color: #212529;\n}\n\n.launch-card-edit-btn {\n  background: none;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 4px 10px;\n  cursor: pointer;\n  color: #6c757d;\n  font-size: 12px;\n  transition: background 0.15s;\n}\n\n.launch-card-edit-btn:hover {\n  background: #f8f9fa;\n  color: #212529;\n}\n\n.launch-card-months {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 8px;\n  min-height: 22px;\n}\n\n.launch-month-badge {\n  background: #d1e7dd;\n  color: #0a3622;\n  border-radius: 4px;\n  padding: 2px 7px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.launch-card-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.launch-card-info-item strong {\n  color: #495057;\n}\n\n/* ── Bloco de período (lançamento) ── */\n.launch-period-box {\n  border: 1px solid #b6d4fe;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  background: #f0f6ff;\n}\n\n.launch-period-box-title {\n  font-size: 11px;\n  font-weight: 700;\n  color: #0056b3;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px;\n}\n\n/* ── Linha de dias da semana ── */\n.launch-weekdays-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 4px;\n  margin-top: 8px;\n}\n\n.launch-weekday-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n}\n\n.launch-weekday-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #495057;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.launch-weekday-cell input[type=\"checkbox\"] {\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n  accent-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
